/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { PendingTelemetryFlusher } from "./PendingTelemetryFlusher";

/**
 * Tracks whether Sage identity (bodyId / partnerId) has been established.
 *
 * All three telemetry loggers consult this one flag: Sage stamps `apiKey`,
 * `sessionId` and `bodyId` onto an event at log time, so anything emitted
 * before device provisioning has to be queued rather than sent, or it ships
 * attributed to the default body id. Sign-in attempts that fail never reach
 * provisioning at all, so their events depend entirely on the queue.
 */
export class SageIdentityGate {
  private static mIsReady: boolean = false;

  public static isReady(): boolean {
    return SageIdentityGate.mIsReady;
  }

  public static markReady(): void {
    SageIdentityGate.mIsReady = true;
  }

  /** Marks identity ready, then replays everything queued before it landed. */
  public static async onSageIdentityAvailable(): Promise<void> {
    SageIdentityGate.markReady();
    await PendingTelemetryFlusher.flush();
  }

  /** Reset static state — test-only. */
  public static resetForTest(): void {
    SageIdentityGate.mIsReady = false;
  }
}
